/**
 * The one Learn file that's yours. Missions in the Learn tab point your agent here ("change the heading on the Learn
 * page to …"), and the page notices the change by itself, through hot reload in the preview. Change anything in it.
 *
 * Everything else in src/learn is cpg.computer's: it is replaced when cpg.computer updates the Learn tab, and the
 * house rules check it hasn't been edited.
 */
export const page = {
  /** The big heading at the top of the Learn tab. Mission "Edit this page" asks your agent to change it. */
  heading: 'Learn to build with your agent',
}

export type LearnPage = typeof page
